class CustomPincodeChecker extends HTMLElement {
    constructor() {
        super();
        this.responseData = {};
        this.getPincodeDetails = this.getPincodeDetails.bind(this);
        this.fetchPincodeDetailsFromGoogleAPI = this.fetchPincodeDetailsFromGoogleAPI.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.handleNumericInput = this.handleNumericInput.bind(this); // Bind the new method
    }

    connectedCallback() {
        // Select elements
        this.pincodeButton = this.querySelector('.pincode-checker-button');
        this.inputPincode = this.querySelector('.pincode-checker-input');
        this.resultDisplay = this.querySelector('.fetched-comment');
        this.errorMessage = this.querySelector('.error-message');
        this.staticMessage = this.querySelector('.static-message');
        this.responseContainer = this.querySelector('.response-container');
        this.loader = this.querySelector('.loader'); // Loader element

        // Attach event listeners
        if (this.pincodeButton) {
            this.pincodeButton.addEventListener('click', this.getPincodeDetails);
        }

        if (this.inputPincode) {
            // Restrict input to numbers only
            this.inputPincode.addEventListener('input', this.handleNumericInput);

            // Allow fetch call on Enter key press
            this.inputPincode.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    this.getPincodeDetails();
                }
            });
        }
    }

    // Restrict input to numeric values only
    handleNumericInput(event) {
        const inputField = event.target;
        inputField.value = inputField.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
    }

    async getPincodeDetails() {
        const inputPincode = this.inputPincode.value.trim();

        // Clear previous results and show loader
        this.resultDisplay.textContent = '';
        this.staticMessage.textContent = '';
        this.errorMessage.textContent = ''; // Clear previous error messages
        this.responseContainer.classList.remove('hide-container');
        this.loader.classList.remove('hide-loader');

        // Validate pincode input
        if (inputPincode.length === 6 && /^[0-9]+$/.test(inputPincode)) {
            await this.fetchPincodeDetailsFromGoogleAPI(inputPincode);

            if (Object.keys(this.responseData).length > 0) {
                this.displayResult(this.responseData);
            } else {
                this.displayResult({ error: `This pincode is not servicable. Please try another.` });
            }
        } else {
            const error = inputPincode.length < 6 || inputPincode.length === 0
                ? `Please enter a 6-digit pincode.`
                : 'Invalid Pincode. Please enter a 6-digit numeric pincode.';
            this.displayResult({ error });
        }

        // Hide loader after processing
        this.loader.classList.add('hide-loader');
    }

    async fetchPincodeDetailsFromGoogleAPI(pincode) {
        const sheetId = '1_yn98yV2mzTdA9AbXuZ9ICPN3an0IkXrNb6tQsgfiTY';
        const apiKey = 'AIzaSyBsroydX6_OhBQPac_ghbmYo86qy2yIq5c';
        const range = 'FreeDeliverypincodes!A:Z';
    
        const apiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${range}?key=${apiKey}`;
    
        // Set a timeout for the fetch request
        const fetchWithTimeout = (url, options, timeout = 5000) => {
            return Promise.race([
                fetch(url, options),
                new Promise((_, reject) =>
                    setTimeout(() => reject(new Error('Request timed out')), timeout)
                ),
            ]);
        };
    
        try {
            const response = await fetchWithTimeout(apiUrl);
    
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
    
            const data = await response.json();
            const rows = data.values;
            const header = rows[0];
            const records = rows.slice(1);
    
            // Match pincode with fetched data
            const matchedRow = records.find((row) => row[0]?.trim() === pincode);
    
            if (matchedRow) {
                const details = {};
                header.forEach((key, index) => {
                    details[key.trim()] = matchedRow[index]?.trim();
                });
                this.responseData = { ...details };
            } else {
                this.responseData = {}; // No match found
            }
        } catch (error) {
            // Handle errors (network, timeout, or API response errors)
            console.error('Error fetching pincode details:', error);
    
            let errorMessage = 'Something went wrong. Please try again.';
            if (error.message === 'Failed to fetch') {
                errorMessage = 'Unable to connect. Please check your network and retry.';
            } else if (error.message === 'Request timed out') {
                errorMessage = 'The request took too long. Please try again later.';
            }
    
            this.responseData = { error: errorMessage }; // Set error response
        }
    }
    

    formatDate(daysCount) {
        let newDate = new Date( // Create a new Date object
            new Date().setDate( // Modify the date
                new Date().getDate() + daysCount // Add 2 days to the current date
            )
        )

        const options = { month: 'short', day: '2-digit' };
        return newDate.toLocaleDateString('en-US', options);
    }

    displayResult(resultData) {
        if (resultData.error) {
            this.errorMessage.classList.remove('hide-error-message');
            this.errorMessage.innerHTML = `<span class="">${resultData.error}</span>`;
            this.staticMessage.textContent = '';
            this.resultDisplay.textContent = '';
        } else {

            if (resultData.Surface === '') {
                // Calculate the delivery date for 2 days from today
                const twoDays = this.formatDate(2);

                // Calculate the delivery date for 4 days from today
                const fourDays = this.formatDate(4);
                const expressDeliveryDaysCount = parseInt(resultData.Express);
                const ExpressDynamicMessage = resultData.EMessage;
                const freeText = resultData.EFreetext;

                this.staticMessage.innerHTML = `
                    <h4 class="express-pincode">Order Today</h4>
                    <li class="express-pincode-delivery-text"><span class="free-text">${freeText} </span>${ExpressDynamicMessage}  ${twoDays} to ${fourDays}</li>`;
                    this.resultDisplay.innerHTML = `<h4 class="free-delivery-pincodes-fetched-comment-text">${resultData.Comment}</h4>`;
                this.errorMessage.classList.add('hide-error-message');
            } else {
                // These are the normal days count of Surface and Express deliveries
                const surfaceDeliveryDaysCount = parseInt(resultData.Surface);
                const expressDeliveryDaysCount = parseInt(resultData.Express);

                const StandardDynamicMessage = resultData.SMessage;
                const ExpressDynamicMessage = resultData.EMessage;
                
                // It is the start date of Surface delivery
                const standardDeliveryDays = this.formatDate(surfaceDeliveryDaysCount);

                // It is the start date of Express delivery
                const expressDeliveryDays = this.formatDate(expressDeliveryDaysCount);

                // These are the additional days count of Surface and Express deliveries
                const surfaceAdditionalDays = surfaceDeliveryDaysCount + parseInt(resultData.SRange);
                const expressAdditionalDays = expressDeliveryDaysCount + parseInt(resultData.ERange);

                // It is the last date of Surface delivery
                const additionalSurfaceDate = this.formatDate(surfaceAdditionalDays);

                // It is the last date of Express delivery
                const additionalExpressDate = this.formatDate(expressAdditionalDays);
                

                this.resultDisplay.innerHTML = `<h4 class="standard-delivery-pincodes-fetched-comment-text">${resultData.Comment}</h4>`;
                this.staticMessage.innerHTML = `
                    <h4 class="not-express-pincode">Order Today</h4>
                    <li class="standard-delivery-text">${StandardDynamicMessage}  ${standardDeliveryDays} to ${additionalSurfaceDate}</li>
                    <li class="express-delivery-text">${ExpressDynamicMessage}  ${expressDeliveryDays} to ${additionalExpressDate}</h4>`;
                this.errorMessage.classList.add('hide-error-message');
            }
        }
    }

    disconnectedCallback() {
        if (this.pincodeButton) {
            this.pincodeButton.removeEventListener('click', this.getPincodeDetails);
        }
        if (this.inputPincode) {
            this.inputPincode.removeEventListener('input', this.handleNumericInput);
        }
    }
}

// Define the custom element
customElements.define('custom-pincode-checker', CustomPincodeChecker);
